import React from 'react'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import DropdownBar from '@ifca-root/react-component/src/components/SpecialBar/DropdownBar'
import { SearchBar } from '@ifca-root/react-component/src/components/SpecialBar/SearchBar'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { useGetUsersByAccountAndSoftwareQuery } from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { UsefulLifeEntryList } from './UsefulLifeList/UsefulLifeEntryList'
import { UsefulLifePostingList } from './UsefulLifeList/UsefulLifePostingList'

export const UsefulLifeMain = (props: any) => {
  let history = useHistory()
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  /* -------------------------------------------- */
  /*                   VARIABLES                  */
  /* -------------------------------------------- */

  const approvalStatusEnum = [
    { name: 'Draft', ID: 'ACTIVE' },
    { name: 'Submitted', ID: 'SUBMIT' },
    { name: 'Approved', ID: 'COMPLETED' },
    { name: 'Rejected', ID: 'REJECTED' },
    { name: 'All', ID: 'ALL' },
  ]

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */

  const [postIDs, setPostIDs] = useState<Set<any>>(new Set([]))
  const [openExitConf, setOpenExitConf] = useState(null)
  const [listStatus, setListStatus] = useState<string>(
    getSearch?.option ?? 'ACTIVE'
  )

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  let dummyData = [
    {
      ID: 1,
      Name: 'Computer pheripheral',
      AssetNo: 'A-000012',
      InitialValue: 60,
      UpdatedValue: 40,
      Description: 'Change description here',
      Date: '2021-05-27T12:44:01.162Z',
      ApprovalStatus: 'ACTIVE',
    },
    {
      ID: 2,
      Name: 'Machinery',
      AssetNo: 'A-000013',
      InitialValue: 90,
      UpdatedValue: 80,
      Description: 'Change description here',
      Date: '2021-05-27T12:44:01.162Z',
      ApprovalStatus: 'ACTIVE',
    },
    {
      ID: 3,
      Name: 'Machinery',
      AssetNo: 'A-000014',
      InitialValue: 90,
      UpdatedValue: 80,
      Description: 'Change description here',
      Date: '2021-05-27T12:44:01.162Z',
      ApprovalStatus: 'ACTIVE',
    },
  ]

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({ fetchPolicy: 'network-only' })

  /* -------------------------------------------- */
  /*                    SEARCH                    */
  /* -------------------------------------------- */

  const { handleSearch, setOriginalListing } = useFuseSearch()

  const hasChanges = () => {
    if (postIDs?.size === 0) return false
    else return true
  }

  return (
    <>
      {UserLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          hasChanges() === true && listStatus === 'SUBMIT'
            ? setOpenExitConf(true)
            : history.push(`/fixed-assets/${CompanyID}/assets-change`)
        }}
        smTitle="Useful Life"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Useful Life', current: true },
        ]}
      />

      <div className="search-filter with-dropdown-filter">
        <SearchBar
          borderRadius="4px"
          onChangeAction={e => {}}
          defaultValue={getSearch?.name ? getSearch?.name : ''}
          onCloseAction={() => {
            handleSearch('', [])
            setOriginalListing([])
          }}
          isDefaultValue={!!getSearch?.name}
        />

        <DropdownBar
          options={approvalStatusEnum}
          setOptionID={setListStatus}
          borderRadius="4px"
          defaultOption={approvalStatusEnum
            ?.map(opt => opt.ID)
            .indexOf(listStatus ?? 'ACTIVE')}
          searchFilter={getSearch}
        />
      </div>

      {(listStatus === 'ACTIVE' ||
        listStatus === 'COMPLETED' ||
        listStatus === 'REJECTED') && (
        <UsefulLifeEntryList
          filteredList={dummyData}
          listStatus={listStatus}
          userList={getUsersByAccountAndSoftware}
          setOriginalListing={setOriginalListing}
        />
      )}

      {listStatus === 'SUBMIT' && (
        <UsefulLifePostingList
          filteredList={dummyData}
          listStatus={listStatus}
          postIDs={postIDs}
          setPostIDs={setPostIDs}
          userList={getUsersByAccountAndSoftware}
          setOriginalListing={setOriginalListing}
        />
      )}

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onClick={() => {
          history.push(`/fixed-assets/${CompanyID}/assets-change/useful-life`)
        }}
      />
    </>
  )
}
